import { Helmet } from "react-helmet-async";

const SITE_URL = "https://nyaliplazaltd.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export const Seo = ({ title, description, path = "", image = DEFAULT_IMAGE, jsonLd }) => {
  const fullTitle = title
    ? `${title} | Nyali Plaza`
    : "Nyali Plaza — Shopping Mall Directory, Mombasa";
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Nyali Plaza" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        Array.isArray(jsonLd)
          ? jsonLd.map((obj) => (
              <script key={obj["@type"] || JSON.stringify(obj).slice(0, 24)} type="application/ld+json">{JSON.stringify(obj)}</script>
            ))
          : <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
